import { useState, useEffect, useMemo } from 'react';
import Cookies from 'js-cookie';

import salesChannelServices from '@sellermodules/saleschannel/services/graphql';
import gqlServices from '@modules/theme/services/graphql';

import View from '@modules/theme/layout/components/seller/StoreReauthorizationModal/view';

const Core = (props) => {
    const { data, loading, refetch } = gqlServices.csStores({
        variables: {
            first: 1000,
            page: 1,
        },
    });

    const storeNotAuthorized = useMemo(() => data?.csStores?.data?.filter(({ status }) => !status), [data]);

    const [dataMp, setDataMp] = useState({});
    const [open, setOpen] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);

    const [csConfig] = salesChannelServices.csConfig();
    const handleReconnect = async (store) => {
        setOpen(false);
        window.backdropLoader(true);
        let config = null;
        config = await csConfig();
        setDataMp({
            store_id: store.store_id,
            code: store?.channel?.channel_code,
            brandId: store?.brands?.[0]?.store_brand_id || '',
            logo: store?.channel?.channel_logo,
            connector: config?.data?.csConfig?.shopify_connector_channel_code?.split(',')?.includes(store?.channel?.channel_code),
        });
        window.backdropLoader(false);
        setOpenDialog(true);
    };

    useEffect(() => {
        if (!loading && storeNotAuthorized?.length && !Cookies.get('store_integration')) {
            setOpen(true);
        }
    }, [loading, storeNotAuthorized]);

    const contentProps = {
        ...props,
        openDialog,
        setOpenDialog,
        handleReconnect,
        dataMp,
        setDataMp,
        open,
        setOpen,
        storeNotAuthorized,
        loading,
        callbackAfterReconnect: () => {
            refetch();
            setOpen(true);
        },
    };

    return (
        <View {...contentProps} />
    );
};

export default Core;
